export default __webpack_public_path__ + "static/media/drawing-4.89de708a.png";